import * as ReachAlertDialog from '@reach/alert-dialog';
import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

export type AlertModalTitleProps = ReachAlertDialog.AlertDialogLabelProps & Omit<ComponentProps<'div'>, 'ref'>;

export const AlertModalTitle = memo(({ className, ...restOfProps }: AlertModalTitleProps) => {
  return (
    <ReachAlertDialog.AlertDialogLabel
      className={classNames('font-semibold text-24 text-grey-12', className)}
      {...restOfProps}
    />
  );
});

AlertModalTitle.displayName = 'AlertModalTitle';
